/**
 * Renders a tab list and tab panels
 * @property {array} tabContents - Array of the contents of the tab panels
 * @property {array} tabNames - Array of the names to be shown on the tab list
 */

import React from 'react';
import { Link } from 'react-router-dom';

const Tabs = class Tabs extends React.Component {
  constructor(props) {
    super(props);

    // Set the initial state
    this.state = {
      activeTab: this.props.activeTab || 0
    }
  }

  render() {
    const { tabClassName, tabContents, tabs } = this.props;

    return (
      <div className="tab-wrap">
        <ul className="tab-list">
          {tabs.map((tab, i) =>
            <li key={i}>
              {!tab.url &&
                <button
                  className={`tab${
                    i === this.state.activeTab ? ' tab--active' : ''
                  }${
                    tabClassName && ` ${tabClassName}`
                  }`}
                  onClick={() => this.setState({ activeTab: i })}
                >
                  {tab.title}
                </button>
              }

              {tab.url &&
                <Link
                  className={`tab ${i === this.state.activeTab ? 'tab--active' : ''}`}
                  to={tab.url}
                  title={tab.title}
                  onClick={() => this.setState({ activeTab: i })}
                >
                  {tab.title}
                </Link>
              }
            </li>
          )}
        </ul>

        {tabContents && tabContents.map(
          (tabContent, i) => {
            if (i === this.state.activeTab) {
              return (
                <div className="tab-panel" key={i}>
                  {tabContent}
                </div>
              )
            }

            return null;
          }
        )}
      </div>
    )
  }
}

export default Tabs;